module.exports = __webpack_public_path__ + "img/colorWheel.c4562944.png";